export default "__VITE_ASSET__BHWE9dMK__"